import { Instagram } from "lucide-react";
import Reveal from "@/components/Reveal";
import { INSTAGRAM_URL } from "@/components/Logo";

export default function InstagramBand() {
  return (
    <section className="relative py-28 bg-card/30 border-y hairline overflow-hidden">
      <div className="absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-gold/8 blur-[130px]" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-gold/10 border border-gold/25 text-gold">
            <Instagram size={26} />
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-6 tracking-tight">
            Proctologia senza tabù, <span className="italic text-gold">anche su Instagram</span>
          </h2>
          <p className="mt-5 text-silver font-light text-lg leading-relaxed max-w-xl">
            Ogni giorno pubblico contenuti chiari e sereni per parlare di proctologia senza giri di
            parole: per abbattere le paure prima ancora di entrare in studio.
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-band-follow-button"
            className="mt-8 inline-flex items-center gap-2 bg-gold text-ink font-semibold rounded-full px-7 py-3.5 hover:bg-goldlight transition-all hover:shadow-[0_0_36px_rgba(212,163,89,0.3)]"
          >
            <Instagram size={18} /> Seguimi su Instagram
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative rounded-[2rem] border border-gold/20 bg-elevated/70 backdrop-blur p-8 max-w-md mx-auto">
            <div className="flex items-center gap-4">
              <span className="flex items-center justify-center w-16 h-16 rounded-full bg-gold/15 border border-gold/30 text-gold">
                <Instagram size={28} />
              </span>
              <div className="min-w-0">
                <p className="font-display text-lg sm:text-xl text-ivory break-all">@robertodilorenzo_proctologo</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-gold mt-1">Instagram ufficiale</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
